/**
 * 请求登录验证，如果没有登录，不能访问页面，返回到登录页面
 */
import router from "./router";
import $store from '@/store';

//路由判断登录，根据路由配置文件的参数
router.beforeEach((to, from, next) => {
    //判断该路由是否需要登录权限
    //record.meta.requireAuth是获取到该请求中携带的该参数
    if (to.matched.some(record => record.meta.requireAuth)) {
        //判断当前的登录状态
        if ($store.state.hasLogin) {
            //如果指向的是登录页面，不做任何操作
            if (to.path === "/login") {

            } else {
                //如果不是登录页面，且token存在，就放行
                next()
            }
        } else {
            // 如果token不存在  前往登录
            next({path: '/login'})
        }

    } else {
        //如果不需要登录认证，就直接访问
        next()
    }
})

//添加时间原型格式化时间 new Date().format("yyyy-MM-dd hh:mm:ss");
Date.prototype.format = function (fmt) { //author: meizz
    let o = {
        "M+": this.getMonth() + 1, //月份   
        "d+": this.getDate(), //日   
        "h+": this.getHours(), //小时   
        "m+": this.getMinutes(), //分   
        "s+": this.getSeconds(), //秒   
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
        "S": this.getMilliseconds() //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}